// src/components/modals/BadgeDetailModal.js
import React from 'react';
import { Modal } from 'react-bootstrap';

const BadgeDetailModal = ({ show, handleClose, badge }) => {
  if (!badge) return null;

  const { bigUrl, collectionName, tokenId, contract } = badge;

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {collectionName}
          {tokenId ? ` #${tokenId}` : ''}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Badge artwork */}
        <div className="text-center">
          <img
            src={bigUrl}
            alt={collectionName}
            style={{ maxWidth: '100%', borderRadius: '10px', height: 'auto' }}
          />
        </div>

        {/* Links */}
        {tokenId && contract && (
          <div style={{ marginTop: '20px' }}>
            <strong>Token ID:</strong> {tokenId}
            <br />
            <a
              href={`https://basescan.org/nft/${contract}/${tokenId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#39ff14' }}
            >
              View on Base Explorer
            </a>
            <br />
            <a
              href={`https://opensea.io/assets/base/${contract}/${tokenId}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#39ff14' }}
            >
              View on OpenSea
            </a>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default BadgeDetailModal;
